"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hydrate = hydrate;

var _clientRenderer2 = require("./clientRenderer");

/**
 * Called during client-side pass, this iterates over the components placed in
 * sharify's render queue and mounts them via React.hydrate. Components are
 * accessible via `sharify.stitch.components`.
 */
function hydrate(_ref) {
  var modules = _ref.modules,
      sharifyData = _ref.sharifyData,
      wrapper = _ref.wrapper;

  var _clientRenderer = (0, _clientRenderer2.clientRenderer)({
    modules: modules,
    wrapper: wrapper
  }),
      components = _clientRenderer.components,
      mount = _clientRenderer.mount;

  sharifyData.stitch.renderQueue.forEach(function (component) {
    mount(component);
  }); // @ts-ignore FIXME: Type properly

  sharifyData.stitch.components = components;
}
//# sourceMappingURL=hydrate.js.map